import styled from 'styled-components';

const MenuWrapper = styled.div`
  width: 250px;
`;

export default MenuWrapper;
